import { useDispatch, useSelector } from "react-redux";
import { apiGetAccountingTypes } from "api/accountingTypeApi";
import BasicSelect from "components/BasicInputs/BasicSelect";
import BasicDateInput from "components/BasicInputs/BasicDateInput";
import { apiGetReportTransActions } from "api/reportApi";
import { setQueryParam } from "helpers/queryParam";

const ReportTransactionSelector = (props: { setDates: any ,fromDate:string,toDate:string}) => {
    const dispatch = useDispatch();
    const {setDates,fromDate,toDate}=props
    const paginationState = useSelector((state: any) => state.paginationReducer);
    const { accountingTypesList } = useSelector((state: any) => state).accountingReducer as {
        accountingTypesList: accountTypeType;
    };


    const submit = () => {
        let options = {}
        if (fromDate && toDate) {
            options = {
                column: "date",
                primarySearch: fromDate,
                secondarySearch: toDate,
                filterType: '7'
            }

        }


        // @ts-ignore
        dispatch(apiGetReportTransActions({ pagination: paginationState, options }));
    };

    // useEffect(() => {
    //   dispatch(apiGetAccountingTypes(token, "all"));
    // }, []);

    const options: any = {
        title: accountingTypesList.title,
        id: "main",
        childs:
            accountingTypesList.childs && accountingTypesList.childs.map((x: any) => ({ ...x, parentId: "main" })),
    };

    return (
        <div className="flex flex-wrap gap-5 my-5">
            <div style={{ minWidth: 300 }}>
                <BasicDateInput
                    range
                    placeholder="کل سال مالی"
                    onChange={(dates) => {
                        setDates(dates)
                        // submit()
                    }}
                // defaultValues={fromDate  && [fromDate, toDate]}
                />
            </div>
            <BasicSelect
                style={{ minWidth: 300 }}
                options={options || []}
                isNested
                onChange={(val, item) => {
                    setQueryParam("accountTypeId", item?.id)
                    submit()

                }}
                placeholder="حساب"
                withSearch
                withRefresh
                // @ts-ignore
                refreshList={() => dispatch(apiGetAccountingTypes(undefined, "all"))}
            />
        </div>
    );
};

export default ReportTransactionSelector;
